import React from "react";
import { Container, Modal, Button } from "@themesberg/react-bootstrap";
import "./timeline.css";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllTimelinePermohonan,
  reset,
} from "../../../features/permohonan/TimelineSlice";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";

const ModalPermohonanTimeline = ({ id, ...props }) => {
  const token = localStorage.getItem("token");
  const { data, isLoading, isError } = useSelector((state) => state.timeline);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(reset());
    dispatch(GetAllTimelinePermohonan({ id, token }));
  }, [dispatch, token]);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Timeline</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <h5>Loading...</h5>
        ) : isError ? (
          <h5>Oops, something went wrong!</h5>
        ) : (
          <VerticalTimeline events={data?.data} />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

const TimelineEvent = ({ idx, date, title, content, user }) => {
  return (
    <li className="timeline-inverted">
      <div className="timeline-badge">{idx}</div>
      <div className="timeline-panel">
        <div className="flex-container flex-around">
          <div className="timeline-heading">
            <h6 className="timeline-title">{title}</h6>
            <span>{content || ""}</span>
            <b>{user}</b>
          </div>
          <div className="timeline-clock">
            <FontAwesomeIcon icon={faCalendar} />
            &nbsp;<i>{date}</i>
          </div>
        </div>
      </div>
    </li>
  );
};

const VerticalTimeline = ({ events }) => {
  return (
    <div className="timeline-wrapper">
      <Container>
        <ul className="timeline">
          {events.map((event, index) => {
            let status_approval = event.catatan ? `${event.catatan} | ` : '';
            if (event.status_approval === "2") {
              status_approval = `Revisi - ${event.catatan} | `;
            } else if (event.status_approval === "3") {
              status_approval = `Ditolak oleh `;
            }
            return (
              <TimelineEvent
                key={index}
                idx={index + 1}
                date={moment(event.tanggal_verifikasi).format(
                  "DD MMM YYYY HH:mm:ss"
                )}
                title={event.nama_status}
                content={status_approval}
                user={event.nama_user}
              />
            );
          })}
        </ul>
      </Container>
    </div>
  );
};

export default ModalPermohonanTimeline;
